module.exports = __webpack_public_path__ + "img/chest-yellow-2x.24c482d0.png";